import React from 'react'
import type { Icon } from 'shared/utils'

const Face = (props: Icon) => {
    const { color = 'white', size = 49, className = 'face' } = props
    return (
        <svg className={className} width={size} height={size} fill={color}>
            <g fill="none" fillRule="evenodd">
                <circle
                    stroke={color}
                    strokeWidth={3}
                    cx={24.5}
                    cy={24.5}
                    r={23}
                />
                <path
                    d="M33.905 28.273v-4.221a2.162 2.162 0 0 1 1.737 2.11 2.145 2.145 0 0 1-1.737 2.111zm-4.617-2.99a.441.441 0 0 1-.44-.44 1.3 1.3 0 0 0-1.297-1.297c-.704 0-1.297.594-1.297 1.297 0 .242-.176.44-.418.44a.441.441 0 0 1-.44-.44 2.16 2.16 0 0 1 2.155-2.155 2.16 2.16 0 0 1 2.155 2.155c0 .242-.176.44-.418.44zm-5.299 5.321c-1.231 0-3.012-.682-3.012-2.155 0-.242.198-.44.44-.44.241 0 .417.198.417.44 0 .924 1.451 1.297 2.155 1.297.726 0 2.177-.373 2.177-1.297 0-.242.176-.44.418-.44.241 0 .44.198.44.44 0 1.473-1.782 2.155-3.035 2.155zm-4.837-5.76c0 .241-.198.439-.44.439s-.418-.198-.418-.44a2.16 2.16 0 0 1 2.155-2.155 2.16 2.16 0 0 1 2.155 2.155c0 .242-.198.44-.44.44a.441.441 0 0 1-.44-.44c0-.703-.571-1.297-1.275-1.297a1.3 1.3 0 0 0-1.297 1.297zm3.562-9.94c0-.703.571-1.296 1.275-1.296.726 0 1.297.571 1.297 1.297 0 .725-.571 1.297-1.297 1.297a1.281 1.281 0 0 1-1.275-1.297zm-8.62 13.37a2.145 2.145 0 0 1-1.736-2.112c0-1.01.725-1.912 1.737-2.11v4.221zm19.811-5.102V19.28c0-.242-.175-.44-.417-.44h-9.06v-1.824a2.145 2.145 0 0 0 1.738-2.111 2.163 2.163 0 0 0-2.177-2.155 2.158 2.158 0 0 0-2.155 2.155c0 1.033.726 1.913 1.737 2.11v1.826h-9.059c-.242 0-.417.197-.417.44v3.891a3.027 3.027 0 0 0-2.595 2.99c0 1.496 1.1 2.77 2.595 2.99v3.915c0 .241.175.417.417.417h18.976a.404.404 0 0 0 .417-.417v-3.914a3.027 3.027 0 0 0 2.595-2.99c0-1.496-1.1-2.771-2.595-2.99z"
                    fill={color}
                />
            </g>
        </svg>
    )
}

export { Face }
